import { useContext } from "react";
import CheckoutContext from "../../checkout-context";

function ServerErrors() {
  const { serverErrors, textsMapping, removeServerErrors } =
    useContext(CheckoutContext);

  const hasNoErrors = serverErrors === undefined || serverErrors.length === 0;
  if (hasNoErrors) {
    return null;
  }

  return (
    <section className="server-errors">
      <p>{textsMapping.serverErrorsText}</p>
      <ul>
        {serverErrors.map((serverError) => (
          <li
            key={serverError}
            dangerouslySetInnerHTML={{ __html: serverError }}
          />
        ))}
      </ul>

      <button
        type="button"
        className="server-errors__close"
        onClick={removeServerErrors}
      >
        Close
      </button>
    </section>
  );
}

export default ServerErrors;
